import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import { CloseIcon } from "@icarius-icons";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";

const GoalDialog = (props) => {

    const {
        open,
        goals,
        handleChange,
        handleClose,
    } = props;

    const [value, setValue] = useState('');
    const dispatch = useDispatch();

    const handleSubmit = () => {
        const goalSelected = goals.find((item) => item.key === value);

        // value arranca en "" y hay un MenuItem de "Ninguno" con value="", por lo que
        // find puede devolver undefined: sin este control se rompia con
        // "Cannot read properties of undefined (reading 'name')" al confirmar sin elegir meta.
        if (!goalSelected) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOption"), severity: 'error' }));
            return;
        }

        handleChange(`${goalSelected.name} - ${`${getLocalizedString("endDate")}: ${goalSelected.endDate}`} - ${`${getLocalizedString("progressPercentage")}: ${goalSelected.progress}%`}`, value);
        handleClose();
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={'sm'}
            fullWidth
            onClose={handleClose}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {getLocalizedString("chooseGoalsAndObjectives")}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent>
                <FormControl style={{ width: "100%" }}>
                    <InputLabel shrink id={`label-goal`}>{getLocalizedString("goalsAndObjectivesTitle")}</InputLabel>
                    <Select
                        value={value}
                        labelId={`label-goal`}
                        id={`select-goal`}
                        onChange={(e) => setValue(e.target.value)}
                        margin={"none"}
                        displayEmpty
                    >
                        <MenuItem
                            className={"whiteText"}
                            value={''}
                        >
                            {getLocalizedString("none")}
                        </MenuItem>
                        {
                            goals?.map(item => (
                                <MenuItem
                                    className={"whiteText"}
                                    key={item.key}
                                    value={item.key}
                                >
                                    {item.name}
                                    <br />
                                    {`${getLocalizedString("endDate")}: ${item.endDate}`}
                                    <br />
                                    {`${getLocalizedString("progressPercentage")}: ${item.progress}%`}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
            </DialogActions>
        </Dialog>
    )
}

export default GoalDialog;